export { default } from "bullitttime-embermodelsevent/adapters/course-element";
